export default "__VITE_ASSET__qMbMYhlG__"